import type { ToastPosition } from "@lib/config/toastConfig";
import { useEffect, useState } from "react";
import { ToastContainer } from "./ToastContainer";

interface ToastProviderProps {
  position?: ToastPosition;
}

export function ToastProvider({ position = "bottom-right" }: ToastProviderProps) {
  const [reducedMotion, setReducedMotion] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    setReducedMotion(mq.matches);

    const handler = (e: MediaQueryListEvent) => setReducedMotion(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  // Expose reducedMotion for components that need it
  useEffect(() => {
    document.documentElement.classList.toggle("toast-reduced-motion", reducedMotion);
  }, [reducedMotion]);

  return <ToastContainer position={position} />;
}
